/**
 * CustomAvatarPage UI 프리셋 정의
 * variant 기반 설정을 위한 프리셋 모음
 */

/**
 * 배경 그라데이션 프리셋
 */
export interface GradientPreset {
  id: string;
  name: string;
  gradient: string;
  colors: [string, string];
  category: 'dark' | 'light' | 'colorful';
}

export const GRADIENT_PRESETS: GradientPreset[] = [
  {
    id: 'ocean-deep',
    name: '오션 딥',
    gradient: 'linear-gradient(180deg, #0A4766 6.28%, #011828 85.78%)',
    colors: ['#0A4766', '#011828'],
    category: 'dark',
  },
  {
    id: 'midnight-blue',
    name: '미드나이트 블루',
    gradient: 'linear-gradient(180deg, #1E3A5F 6.28%, #0D1B2A 85.78%)',
    colors: ['#1E3A5F', '#0D1B2A'],
    category: 'dark',
  },
  {
    id: 'warm-sunset',
    name: '웜 선셋',
    gradient: 'linear-gradient(180deg, #8B4513 6.28%, #3D1F0D 85.78%)',
    colors: ['#8B4513', '#3D1F0D'],
    category: 'colorful',
  },
  {
    id: 'forest-green',
    name: '포레스트 그린',
    gradient: 'linear-gradient(180deg, #0D4D4D 6.28%, #0A2A2A 85.78%)',
    colors: ['#0D4D4D', '#0A2A2A'],
    category: 'dark',
  },
  {
    id: 'rose-pink',
    name: '로즈 핑크',
    gradient: 'linear-gradient(180deg, #8B3A62 6.28%, #4A1F35 85.78%)',
    colors: ['#8B3A62', '#4A1F35'],
    category: 'colorful',
  },
  {
    id: 'charcoal-gray',
    name: '차콜 그레이',
    gradient: 'linear-gradient(180deg, #4A4A4A 6.28%, #1A1A1A 85.78%)',
    colors: ['#4A4A4A', '#1A1A1A'],
    category: 'dark',
  },
  {
    id: 'purple-haze',
    name: '퍼플 헤이즈',
    gradient: 'linear-gradient(180deg, #5A3E7A 6.28%, #2D1F3D 85.78%)',
    colors: ['#5A3E7A', '#2D1F3D'],
    category: 'colorful',
  },
  {
    id: 'cosmic-night',
    name: '코즈믹 나이트',
    gradient: 'linear-gradient(180deg, #1A1A2E 6.28%, #0F0F1A 85.78%)',
    colors: ['#1A1A2E', '#0F0F1A'],
    category: 'dark',
  },
];

/**
 * 기본 프리셋 ID
 */
export const DEFAULT_GRADIENT_PRESET_ID = 'ocean-deep';

/**
 * 프리셋 ID로 프리셋 찾기
 */
export function getGradientPresetById(id: string): GradientPreset | undefined {
  return GRADIENT_PRESETS.find((p) => p.id === id);
}

/**
 * 그라데이션 문자열로 프리셋 찾기
 */
export function findPresetByGradient(gradient: string): GradientPreset | undefined {
  return GRADIENT_PRESETS.find((p) => p.gradient === gradient);
}

/**
 * 기본 그라데이션 가져오기
 */
export function getDefaultGradient(): string {
  return getGradientPresetById(DEFAULT_GRADIENT_PRESET_ID)?.gradient || GRADIENT_PRESETS[0].gradient;
}
